import React, { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";

// app
import VerifyAddressForm from "../../components/VerifyAddressForm";
import { GoBackButton } from "../../components/Buttons";
import { TermsAndConditionsModal } from "../../components/Modals";
import { FormError } from "../../components/Cards";
import MailCheckInput from "../../components/MailCheck";
import mapAddressToFormValues from "../../utils/mapAddressToFormValues";
import useEmailField from "../../hooks/useEmailField";
import { postAssessmentData, setUserEmail } from "../../redux/actions/assessment";
import { withFormik } from "formik";
import { useHistory } from "react-router";

const CURRENT_STEP = 2;

const PreOrderConfirmationFlow = ({ selectedAddress, values, onSubmit }) => {
  const [isInformationCertified, certifyInformation] = useState(true);
  const [agreeTermsAndConditions, setAgreeTermsAndConditions] = useState(false);
  const [termsAndConditionsModal, setTermsAndConditionsModal] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const { email, handleEmailChangeWithClear } = useEmailField("", formErrors, setFormErrors);
  const dispatch = useDispatch();
  const history = useHistory();

  const goBack = () => {
    onSubmit(CURRENT_STEP - 1);
  };

  const handleCertifyInformationChange = () => {
    certifyInformation((prev) => !prev);
  };

  const handleChangeTermsAndConditions = () => {
    setAgreeTermsAndConditions((prev) => !prev);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const errors = {};
    if (email.error || !email.value) {
      errors.email = "Must be valid email";
    }

    if (!agreeTermsAndConditions) {
      errors.agreeTermsAndConditions = "You must agree with our Terms and Conditions";
    }

    if (isEmpty(errors)) {
      // sets email to store and calls begin-computation
      dispatch(setUserEmail(email.value));
      dispatch(postAssessmentData(null, null, true));
      history.push("/pre-order/submit");
    } else {
      setFormErrors(errors);
    }
  };

  const handleToggleTermsAndConditionsModal = () => {
    setTermsAndConditionsModal((prev) => !prev);
  };

  const EmailField = (
    <MailCheckInput inputText={email.value} handleEmailChange={handleEmailChangeWithClear} useInputAddon={false}>
      {formErrors.email && <FormError>Must enter a valid Email Address.</FormError>}
      <small>We need to know where to send your report. We'll never share your email with anyone.</small>
    </MailCheckInput>
  );

  return (
    <>
      <GoBackButton title="Change Address" onClick={goBack} />
      <VerifyAddressForm
        goBack={goBack}
        values={values}
        disableAll
        selectedAddress={selectedAddress}
        handleCertifyInformationChange={handleCertifyInformationChange}
        isInformationCertified={isInformationCertified}
        agreeTermsAndConditions={agreeTermsAndConditions}
        handleChangeTermsAndConditions={handleChangeTermsAndConditions}
        termsAndConditions
        handleSubmit={handleFormSubmit}
        handleToggleTermsAndConditionsModal={handleToggleTermsAndConditionsModal}
        submitButtonText="Submit"
        submitButtonDisabled={!isInformationCertified}
        AdditionalFields={EmailField}
        errors={formErrors}
      />
      <TermsAndConditionsModal isOpen={termsAndConditionsModal} toggle={handleToggleTermsAndConditionsModal} />
    </>
  );
};

const CreatePreOrderConfirmationWithFormik = withFormik({
  mapPropsToValues: (props) => mapAddressToFormValues(props),
});

PreOrderConfirmationFlow.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  selectedAddress: PropTypes.object,
};

export default CreatePreOrderConfirmationWithFormik(PreOrderConfirmationFlow);
